export const buildHrefFromBreadcrumbs = (
    breadcrumbs: string = '',
    id: number,
    dimension: { id: number },
    subdimension: { id: number },
    options?: { typeOverride?: string; addFilterApplied?: boolean }
) => {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    const parts = breadcrumbs ? breadcrumbs.split('/').map(p => p.trim()) : [];

    if (!url.href.includes('search')) {
        if (parts[1]) params.set('type', options?.typeOverride ?? parts[1]);
        if (parts[2]) params.set('dimensionID', String(dimension.id));
        if (parts[3]) params.set('subdimensionID', String(subdimension.id));
        params.set('indicatorID', String(id));
        params.set('page', '1');
        if (options?.addFilterApplied && (parts[1] || parts[2] || parts[3])) {
            params.set('filterApplied', 'true');
        }
    }

    return url.toString();
};